import { Box, Flex, SimpleGrid } from "@chakra-ui/layout";
import CardSaldo from "components/Cards/CardSaldo";
import Container from "components/Container";
import WithPermission from "components/WithPermission";
import useHasPermission from "features/permissions/hooks/useHasPermission";
import AcoesRapidas from "./components/AcoesRapidas";
import CardAcordos from "./components/CardAcordos";
import CardManutencoes from "./components/CardManutencoes";
import CardMensagens from "./components/CardMensagens";
import CardMoradores from "./components/CardMoradores";
import CardReceitaDespesaResultado from "./components/CardReceitaDespesaResultado";
import CardReceitas from "./components/CardReceitas";
import CardReservaPendente from "./components/CardReservaPendente";
import DashboardHeader from "./components/DashboardHeader";
import { permissionsFor } from "./util";

function DashboardBase() {
  const hasPermissionDashboard = useHasPermission(permissionsFor.Dashboard);
  return (
    <>
      <Container>
        <Box>
          <Flex flexDir="column">
            <DashboardHeader />

            <SimpleGrid
              columns={{ sm: 2, md: 2, lg: 4 }}
              gap="16px"
              mb={hasPermissionDashboard ? "32px" : undefined}
            >
              <WithPermission permissions={permissionsFor.CardMoradores}>
                <CardMoradores />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardAcordos}>
                <CardAcordos />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardReceitas}>
                <CardReceitas />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardSaldo}>
                <CardSaldo />
              </WithPermission>
            </SimpleGrid>

            <SimpleGrid columns={{ sm: 1, lg: 2 }} gap="16px">
              {/* <WithPermission
                  permissions={permissionsFor.CardSaudeFinanceira}
                >
                  <CardSaudeFinanceira />
                </WithPermission> */}
              <SimpleGrid
                gap={{ sm: "16px", md: "16px", lg: 0 }}
                columns={{ sm: 2, lg: 1 }}
              >
                <AcoesRapidas />

                <WithPermission
                  permissions={permissionsFor.CardReceitaDespesaResultado}
                >
                  <CardReceitaDespesaResultado />
                </WithPermission>
              </SimpleGrid>

              <WithPermission permissions={permissionsFor.CardMensagens}>
                <CardMensagens />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardReserva}>
                <CardReservaPendente />
              </WithPermission>

              <WithPermission permissions={permissionsFor.CardManutencoes}>
                <CardManutencoes />
              </WithPermission>

              {/* <CardAnuncioPendente /> */}

              {/* <CardUnidades /> */}
            </SimpleGrid>
          </Flex>
        </Box>
      </Container>
    </>
  );
}

export default DashboardBase;
